module.exports = __webpack_public_path__ + "img/callred.91de4683.png";